module.exports = __webpack_public_path__ + "static/media/main idea.4912257f.mp3";